
import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

const store = createStore({
  plugins:[createPersistedState({
    storage:window.sessionStorage,
  })],
  state:{
    loggedIn:false,
    account:"",
    password:"",
  },
  getters:{
    loggedIn(state){
      return state.loggedIn;
    },
    account(state){
      return state.account;
    },
    password(state){
      return state.password;
    },
  },
  mutations:{
    login(state,{account,password}){
      state.loggedIn = true;
      state.account = account;
      state.password = password;
    },
    logout(state){
      state.loggedIn = false;
      state.account = "";
      state.password = "";
    },
  }
});

export default store